import { ReplaySubject } from 'rxjs';
import { RaiSsoProfile } from '.'
export const login = 'raissoUserLogin';
export const logout ='raissoUserLogout';
export const refresh = 'raissoUserRefresh';
export const privacyRequired = 'rai:privacy-required';
export const privacyPubblicitaRequired = 'rai:privacy-pubblicita-required';
export const userUpdate = "rai:wizard-user-update";
export const userDataUpdate = "rai:wizard-user-data-update";

const event$ = new ReplaySubject<CustomEvent<RaiSsoProfile>>();
export { event$ };

export interface SsoWidgetEventsMap {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  'rai:ssoWidget-openRequest': CustomEvent<{ mode: "registration" } | { mode: "registrationSocial", data: Record<string, any> } | { mode: "activationRequired", data:{title: string, message: string, detail: string}}>,
  'rai:ssoWidget-closeRequest': Event,
  'rai:ssoWidget-closed': Event,
  'rai:ssoWidget-opened': Event,
  'rai:ssoWidget-closedByUser': Event,
}

export interface RaissoEventsMap {
  "raissoUserLogin": CustomEvent<RaiSsoProfile>;
  "raissoUserLogout": Event;
  "raissoUserRefresh": CustomEvent<RaiSsoProfile>;
  "rai:privacy-required": Event;
  "rai:privacy-pubblicita-required": Event;
  "rai:wizard-user-update": CustomEvent<RaiSsoProfile>;
  "rai:wizard-user-data-update": CustomEvent<RaiSsoProfile>;
}

export type EventsMap = RaissoEventsMap & SsoWidgetEventsMap;

declare global {

}
